<template>
  <el-form class="rule-form" :model="formData" :rules="formRules" ref="form">
    <BasicModule
      :formObj="formData"
    />
    <DiscountSetting
      :formObj="formData"
      @update="getFormCase"
    />
    <div class="detail-page-btn">
      <el-button class="egl-btn-white" @click="cancel_fn">{{ $locale("global.cancel") }}</el-button>
      <el-button class="egl-btn-yellow" @click="save_fn">{{ $locale("global.confirm") }}</el-button>
    </div>
  </el-form>
</template>
<script>

import BasicModule from "./BasicModule.vue";
import DiscountSetting from "./DiscountSetting.vue";
import { discountSettingType } from "@/assets/js/discountRuleTemplateDetail";
import { createRule, getRuleDetail, updateRule } from "@/helpers/service/api/discountRuleTemplate";
import countDownAlert from "@/utils/countDownAlert";

export default {
  mounted() {
    if (this.$route.path.indexOf("edit") > -1) {
      getRuleDetail({ id: this.$route.params.id }).then(res => {
        console.log(res.data);
        const {
          name, purchaseSetting, purchaseQty, useOnTheDay, boxOffice, couponCombinedUse,
          movieTicketingCombinedUse, discountRules
        } = res.data;
        this.formData = {
          name,
          purchaseSetting,
          purchaseQty,
          useOnTheDay,
          boxOffice,
          couponCombinedUse,
          movieTicketingCombinedUse,
          discountRules
        };
      });
    } else {
      this.getFormCase(this.formData.purchaseQty);
    }
  },
  data() {
    let  validateApplicableNumber = (rule, value, callback) => {
      if(!value) {
        callback(new Error(this.$locale("discountRules.plsInputQty")));
      } else if(value < 2) {
        callback(new Error(this.$locale("discountRules.qty.less.validate")));
      } else if(value > 10) {
        callback(new Error(this.$locale("discountRules.qty.more.validate")));
      } else {
        callback();
      }
    };
    return {
      formData: {
        name: "",
        purchaseSetting: true,
        purchaseQty: 2,
        useOnTheDay: true,
        boxOffice: true,
        couponCombinedUse: false,
        movieTicketingCombinedUse: false,
        discountRules: []
      },
      formRules: {
        name: [
          { required: true, message: this.$locale("discountRules.plsInputName"), trigger: "blur" }
        ],
        purchaseQty: [
          { validator: validateApplicableNumber, trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    cancel_fn() {
      this.$router.go(-1);
    },
    save_fn() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const isCreate = this.$route.path.indexOf("create") > -1;
          if (isCreate) {
            createRule({ discountRuleTemplateInfo: { ...this.formData, cinemaId: window.localStorage.getItem("cinemaId") } }).then(res => {
              if(res.success) {
                countDownAlert({ content: this.$locale("global.createSuccessfully"), callback: () => {
                  this.$router.go(-1);
                } });
              }
            });
          } else {
            updateRule({ discountRuleTemplateInfo: { ...this.formData, id: this.$route.params.id, cinemaId: window.localStorage.getItem("cinemaId") } }).then(res => {
              if (res.success) {
                countDownAlert({ content: this.$locale("global.updateSuccessfully"), callback: () => {
                  this.$router.go(-1);
                } });
              }
            });
          }
        } else {
          setTimeout(() => {
            const isError = document.getElementsByClassName("is-error");
            if (isError[0].querySelector("input")) {
              isError[0].querySelector("input").focus();
            } else {
              isError[0].querySelector("i").focus();
            }
          }, 100);
          return false;
        }
      });
    },
    getFormCase(number) {
      let arr = [];
      if (number >= 2 && number <= 10) {
        for(let i = 0; i < number - 1; i++) {
          arr.push({
            free: false,
            discountPrice: 0,
            discountRuleType: discountSettingType.get(i),
          });
        }
        this.formData.discountRules = arr;
      } else {
        this.formData.discountRules = [];
      }
    }
  },
  components: {
    BasicModule,
    DiscountSetting
  }
};
</script>